export default {
  rankOrder: {
    ariaAddOption: 'أضف {label} إلى القائمة المرتبة',
    ariaMoveUp: 'تحريك {label} لأعلى',
    ariaMoveDown: 'تحريك {label} لأسفل',
    ariaRemoveOption: 'إزالة {label} من القائمة المرتبة',
  },
  coe: {
    ariaDisclaimer: 'إشعار',
    ariaQuestion: 'سؤال',
    ariaConversationHistory: 'سجل المحادثة',
    ariaYourResponse: 'إجابتك {number}',
    ariaFollowUpQuestion: 'سؤال المتابعة {number}',
    ariaResponseInput: 'حقل الإجابة',
    ariaRespondingTo: 'الإجابة على',
    ariaSendResponse: 'إرسال الإجابة',
    ariaThinking: 'تفكير'
  },
  deviceView: {
    toolbar: 'جهاز المعاينة',
    mobile: 'جوال',
    tablet: 'جهاز لوحي',
    desktop: 'سطح المكتب'
  },
  header: {
    customLogoAlt: 'الشعار',
    defaultLogoAlt: 'شعار QuestDIY'
  }
}
